export const CONTACT_SEND = 'CONTACT_SEND';
